export { default as HomeHero } from './HomeHero'
export { default as HomeIntro } from './HomeIntro'
export { default as HomeWho } from './HomeWho'
export { default as HomeVideo } from './HomeVideo'
export { default as HomeServices } from './HomeServices'
export { default as HomeTestimonials } from './HomeTestimonials'
export { default as HomeCTA } from './HomeCTA'
export { default as HomeBannerToServices } from './HomeBannerToServices'
